export default function ReviewsSection() {
  const reviews = [
    {
      text: 'Ich war äußerst zufrieden mit der Haushaltsauflösung durch Picobello Hausservice. Sie haben professionell und schnell gearbeitet. Alles wurde ordentlich entrümpelt und fachgerecht entsorgt. Ich kann sie wärmstens empfehlen!',
      author: 'Thomas Wagner'
    },
    {
      text: 'Der Möbeltaxi-Service von Picobello Hausservice war ausgezeichnet. Pünktlich, zuverlässig und äußerst freundlich. Meine Möbel wurden sicher und unbeschädigt transportiert. Die Preise waren fair und transparent. Top-Service!',
      author: 'Daniel Neubauer'
    },
    {
      text: 'Picobello Hausservice hat unsere Entrümpelung 1A durchgeführt. Das Team war sehr professionell, höflich und hilfsbereit. Sie haben alle Gegenstände ordentlich entsorgt und die Räume sauber hinterlassen. Absolut empfehlenswert!',
      author: 'Sebastian Wimmer'
    },
    {
      text: 'Ich war sehr zufrieden mit der Arbeit! Ich konnte kurzfristig (5 Tage) eine Zusage bekommen; die Abwicklung und Absprachen liefen schnell und einfach über WhatsApp und auf meine Fragen und Wünsche wurde eingegangen! Alle Teile sind heile (300km Fahrt) angekommen und das Personal ist super freundlich und hilfsbereit. Vielen Dank dafür!!!!',
      author: 'Lea Rössig'
    },
    {
      text: 'Ich habe für meine Eltern eine Firma für Entrümplung gesucht, wo das Preis Leitung Verhältnis passt. Schade das ich nur 5 Sterne vergeben kann da diese Firma definitiv sehr zu empfehlen ist. Der Müll wurde sich im Vorfeld angeschaut und daraufhin ein Angebot erstellt. Der Chef kam sogar ein zweites Mal weil ich noch Fragen zu manchen Sachen hatte. Es wurde alles erklärt und ich bin mehr als zufrieden mit dem ganzen Team.',
      author: 'Sebastian König'
    },
    {
      text: 'Fünf Sterne sind eigentlich zu wenig! Ich kann gar nicht genug loben, wie unglaublich zuverlässig, hilfsbereit und professionell der Entrümpler unseren Umzug organisiert hat – es war eine echte Meisterleistung! Meine 80-jährige Mutter ist ins betreute Wohnen gezogen – eine emotionale und logistisch anspruchsvolle Situation. Doch vom ersten Moment an war klar: Hier sind Profis am Werk, die mitdenken, mitfühlen und einfach anpacken! Schnell, gründlich, respektvoll und dabei auch noch menschlich und warmherzig – so erlebt man das selten. Der gesamte Ablauf war stressfrei, freundlich und absolut fair im Preis. Ich bin mehr als dankbar für die Unterstützung in dieser intensiven Zeit. Wer einen Entrümpler sucht, der mehr als nur „abwickelt", sondern wirklich unterstützt, ist hier genau richtig! Uneingeschränkte Empfehlung – vielen, vielen Dank!',
      author: 'Diana Henniges'
    },
    {
      text: 'Ich bin voll und ganz zufrieden mit picobello gute arbeit und humanitäre preise kann ich nur weiterempfehlen!',
      author: 'Bandi Sound'
    },
    {
      text: 'Guter Service und guter Preis 👍',
      author: 'R J A A R J'
    },
    {
      text: 'Hi, Mega freundlich und sehr schnell. Sehr organisiert und preis Leistung stimmte auch. Kann ich nur empfehlen. Beste Grüße',
      author: 'Sakhawat'
    },
    {
      text: 'Wir waren sehr zufrieden mit der Abholung von Bett und Kleiderschrank. Termin 2 Wochen vorher abgesprochen, sehr netter Kontakt. Preis-Leistungsverhältnis sehr gut. Es gab zwar etwas Verspätung, aber die wurde direkt begründet. Die Abholung lief schnell! Auf jeden Fall zu empfehlen! 👍🏼👍🏼😊',
      author: 'Ines Rühtz'
    },
    {
      text: 'Sehr schnell und zuverlässig. Dabei waren die Mitarbeiter aber sehr vorsichtig, dass keine Schäden entstehen. Der Preis ist auch sehr korrekt. Alles in allem war ich sehr zufrieden. Klare Weiterempfehlung.',
      author: 'Marco Ahrens'
    }
  ];

  return (
    <section id="bewertungen" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Das sagen unsere Kunden
          </h2>
          <p className="text-xl text-gray-600">
            Überzeugen Sie sich von unserer Qualität
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviews.map((review, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-2xl p-8 hover:shadow-xl transition-all duration-300"
            >
              <div className="flex items-center gap-2 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-orange-500 text-lg"></i>
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed mb-6 text-sm">
                "{review.text}"
              </p>
              <p className="text-gray-900 font-semibold text-sm">
                – {review.author}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}